import { render, staticRenderFns } from "./VesselAdministrationWrapper.vue?vue&type=template&id=79fc97a4&scoped=true&"
import script from "./VesselAdministrationWrapper.vue?vue&type=script&lang=ts&"
export * from "./VesselAdministrationWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc97a4",
  null
  
)

export default component.exports